<div class="breadcrumb-wrapper d-flex">
  <div>
    <i class="mdi mdi-cube-outline font-size-20 mr-2"></i>
  </div>
    <h1>{{tittle}}</h1>
  </div>
  <router-outlet></router-outlet>
